import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: {
    themes: {
      light: {
        primary: '#002661',
        secondary: '#044D8F',
        save: '#3C6F25',
        accent: '#5C84C6',
        info: '#044D8F',
        background: "#f4f7fa",
        success: '#FF5A29',
        warning: '#FFC107',
        error: '#C50000',
        accent_light: '#edf3fa',
        admin_primary: '#78909C'
      }
    }
}};

export default new Vuetify(opts)